import React from "react";
import {withRouter} from 'react-router-dom'
import Select from 'react-select';
import { Component } from "react";
import '../css/create.css';
import MultipleImageUploadComponent from './multiple-image-upload.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { CheckLogin, urlWS, GetParamsUserAgent } from '../functions/ifelse.js';
import { getLang } from '../functions/ifelse.js';
import { capitalize } from '../functions/ifelse.js';
import {Link} from 'react-router-dom'

let params = null;
var idiomas = require("../functions/idiomas.json");
var placeID, placeName, beerID;
var styles_beers = [];
var types_recipient,types_made,types_colors,types_volume;


var lang;

var mensaje = "";
var classCompleted = "alert alert-danger";
var followmessage = "";
var userID;

class Add extends Component {
    
    constructor(props){
        super(props);
        
        userID = CheckLogin(props);

        this.state ={
            name:'',
            brand:'',
            color:'gold',
            style:'',
            made:'comercial',
            recipient:'draft',
            volume:'25',
            ingredients:'',
            alcoholPercent:'',
            country:'',
            rating:0,
            comment:'',
            price:'',
            priceHappyHour:'',
            withoutGluten:-1,
            arrayLocalPhotos:[],
            loading:false,
            completed:false
        }
         params = this.props.match.params;
        this.handleStateChangeLP  = this.handleStateChangeLP.bind(this);

        placeID = params.placeID;
        
        lang = getLang();

        styles_beers.push({ label:lang.none, value: "none", selected:"selected"});
        Object.keys(idiomas.styles_beer).forEach(function(key) {
            var array_styles = idiomas.styles_beer[key];
            for (let j = 0 ; j < array_styles.length ; j++) {  
                styles_beers.push({ label:array_styles[j]+ "   ---------   ("+key+")", value:array_styles[j] })
            }
        });

        
        

        types_recipient = lang.beer_recipient;
        types_made = lang.beer_made;
        types_colors = lang.beer_colors;
        types_volume = lang.beer_volume;

        placeName = params.name;
        
    }

    myChangeHandler = (event) => {
        let nam = event.target.name;
        let val = event.target.value;
        if(nam == "withoutGluten"){
            var va = -1;
            if(event.target.checked)
                va = 1;
            this.setState({withoutGluten: va});
        }
        else{
            this.setState({[nam]: val});    
        }
        
    }

    myChangeHandlerStyle = (event) => {
        this.setState({style: event.value});
    }

    handleStateChangeLP(files) {
        this.setState({arrayLocalPhotos:files})
    }

    myClickStar(n) {
        var self= this;
        return function () {
            self.setState({rating:n})
         }
    }

    convertToParamas(objeto){ //operations
        return {
            'name':objeto.name,
            'brand':objeto.brand,
            'color':objeto.color,
            'style':objeto.style,
            'made':objeto.made,
            'recipient':objeto.recipient,
            'volume':objeto.volume,
            'ingredients':objeto.ingredients,
            'alcoholPercent':objeto.alcoholPercent,
            'country':objeto.country,
            'rating':objeto.rating,
            "comment":objeto.comment,
            'price':objeto.price,
            'priceHappyHour':objeto.priceHappyHour,
            'withoutGluten':objeto.withoutGluten,
            "placeID":placeID,
            "userID":userID
        }
     }

  
 
     //,    'arrayGooglePhotos':objeto.arrayGooglePhotos,    'arrayLocalPhotos':objeto.arrayLocalPhotos
 
     mySubmitHandler = (event) => {
         event.preventDefault();
         //aquí debemos de llamar al ws para crear el local y pasar this.state
         var params = this.convertToParamas(this.state);
         const self = this;
         self.setState({ 
             loading:true
         });  
         
         (async () => {
            let data = GetParamsUserAgent();
             const rawResponse = await fetch(urlWS+'beer/create.php'+data, {
               method: 'POST',
               headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json',
                 'Content-Type':'application/x-www-form-urlencoded' //sin esta línea da error
               },
               body: JSON.stringify(params)
             });
             const response = await rawResponse.json();          
             var id = response.id;
             var message = lang.error;
             mensaje = message;
             if(parseInt(id) > 0){
                 beerID = id;
                 message = lang.beer_created;
                 //////////////////////////////////////////////////////LOCAL IMAGES//////////////////////////////////
                 let data = new FormData();
                 let numimages = 0;
                 for (let i = 0 ; i < this.state.arrayLocalPhotos.length ; i++) {   
                     if(this.state.arrayLocalPhotos[i]){
                         data.append('files[]', this.state.arrayLocalPhotos[i], this.state.arrayLocalPhotos[i].name);
                         numimages++;
                     }
                 }
                 data.append('userID', userID);
                 if(numimages > 0){
                     (async () => {
                        let data4 = GetParamsUserAgent();
                         const rawResponse = await fetch(urlWS+'beer/addphotos.php'+data4+'&id='+id, {
                           method: 'POST',
                           body: data
                         });
                         const response = await rawResponse.json();
                         
                         var res = response.id;
                         if(res <= 0){
                             message += lang.place_addphotos_error;
                         }
     
                         mensaje = message;
                         classCompleted = "alert alert-success";
                         followmessage = lang.add_beers;
                         self.setState({ 
                             loading:false,
                             completed:true
                         });  
                         
                       })();
                 }
                 else{
                     mensaje = message;
                     classCompleted = "alert alert-success";
                     followmessage = lang.add_beers;
                     self.setState({ 
                         loading:false,
                         completed:true
                     });  
                 }
                 //////////////////////////////////////////////////////FIN LOCAL IMAGES//////////////////////////////////
 
             }else{
                 self.setState({ 
                     loading:false,
                     completed:true
                 });  
             }            
           })();
       }

    refreshPage() {
        window.location.reload(false);
    }

    render() {
        if(this.state.loading == true){
            return(
            <div className="loading_center">
                <div className="spinner-grow text-primary" role="status">
                <span className="sr-only">Loading...</span>
                </div>
                <div className="spinner-grow text-secondary" role="status">
                <span className="sr-only">Loading...</span>
                </div>
                <div className="spinner-grow text-success" role="status">
                <span className="sr-only">Loading...</span>
                </div>
                <div className="spinner-grow text-danger" role="status">
                <span className="sr-only">Loading...</span>
                </div>
                <div className="spinner-grow text-warning" role="status">
                <span className="sr-only">Loading...</span>
                </div>
                <div className="spinner-grow text-info" role="status">
                <span className="sr-only">Loading...</span>
                </div>
                <div className="spinner-grow text-light" role="status">
                <span className="sr-only">Loading...</span>
                </div>
                <div className="spinner-grow text-dark" role="status">
                <span className="sr-only">Loading...</span>
                </div>
            </div>
            );
        }
        else if(this.state.completed == true){
            return(
                <div className="loading_center">
                    <div className={classCompleted}>
                        <div>{mensaje}</div>                        
                        <Link href="#" onClick={this.refreshPage}>{lang.add_more_beer}</Link>
                        <br></br>
                        <Link to={"/place/"+placeID+"/"+beerID}>{lang.home}</Link>
                    </div>
                </div>
                );
        }
        else{
        return (
            <div className="container h-100">
                <form className="well form-horizontal" onSubmit={this.mySubmitHandler}  id="contact_form">
                <fieldset>
                
                <div className="form-group col-md-6 margin-top-20"><h3><b>{placeName} - {lang.add_beer}</b></h3></div>
                
                
                <div className="card">
                    <div className="card-body">
                    <div className="card-title">{lang.required_params}</div>
                    <div className="card-text">
                        <div className="form-group">
                            <label className="col-md-6 control-label">{capitalize(lang.name)}</label>  
                            <div className="col-md-6 inputGroupContainer">
                                <div className="input-group">
                                    <span className="input-group-addon"><i className="glyphicon glyphicon-user"></i></span>
                                    <input name="name" required placeholder={lang.name_placeholder} value={this.state.name} onChange={this.myChangeHandler} className="form-control"  type="text"/>
                                </div>
                            </div>
                            </div>

                        

                            <div className="form-group">
                            <label className="col-md-6 control-label">{capitalize(lang.price)}</label>  
                            <div className="col-md-6 inputGroupContainer">
                                <div className="input-group">
                                    <span className="input-group-addon"><i className="glyphicon glyphicon-user"></i></span>
                                    <input required  type="number" placeholder={lang.price_placeholder}  name="price" value={this.state.price} onChange={this.myChangeHandler} className="form-control" pattern="^\d*(\.\d{0,2})?$" step=".01"/>
                                </div>
                            </div>
                            </div>

                            <div className="form-group"> 
                                <label className="col-md-6 control-label">{capitalize(lang.volume)}</label>
                                    <div className="col-md-6 selectContainer">
                                    <div className="input-group">
                                        <span className="input-group-addon"><i className="glyphicon glyphicon-list"></i></span>
                                    <select name="volume" className="form-control selectpicker" onChange={this.myChangeHandler}>
                                        {Object.keys(types_volume).map(key => 
                                        <option  selected={key == "25"} key={key} value={key}>{types_volume[key]}</option>                          
                                        )}
                                    </select>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group"> 
                            <label className="col-md-6 control-label">Color</label>
                                <div className="col-md-6 selectContainer">
                                <div className="input-group">
                                    <span className="input-group-addon"><i className="glyphicon glyphicon-list"></i></span>
                                    <select name="color" className="form-control selectpicker" onChange={this.myChangeHandler}>
                                        {Object.keys(types_colors).map(key => 
                                        <option  selected={key == "gold"} key={key} value={key}>{types_colors[key]}</option>                          
                                        )}
                                    </select>
                            </div>
                            </div>
                            </div>

                            

                            <div className="form-group">
                            <label className="col-md-6 control-label">{capitalize(lang.made)}</label>  
                            <div className="col-md-6 inputGroupContainer">
                                <div className="input-group">
                                    <span className="input-group-addon"><i className="glyphicon glyphicon-user"></i></span>
                                    <select name="made" className="form-control selectpicker" onChange={this.myChangeHandler}>
                                        {Object.keys(types_made).map(key => 
                                        <option key={key} value={key}>{types_made[key]}</option>                          
                                        )}
                                    </select>
                                </div>
                            </div>
                            </div>

                            <div className="form-group"> 
                                <label className="col-md-6 control-label">{capitalize(lang.recipient)}</label>
                                    <div className="col-md-6 selectContainer">
                                    <div className="input-group">
                                        <span className="input-group-addon"><i className="glyphicon glyphicon-list"></i></span>
                                    <select name="recipient" className="form-control selectpicker" onChange={this.myChangeHandler}>
                                        {Object.keys(types_recipient).map(key => 
                                        <option key={key} value={key}>{types_recipient[key]}</option>                          
                                        )}
                                    </select>
                                    </div>
                                </div>
                            </div>
                    </div>
                    </div>
                </div>



                <div className="card">
                    <div className="card-body">
                    <div className="card-title">{lang.optional_params}</div>
                    <div className="card-text">
                        
                        <div className="form-group"> 
                        <label className="col-md-6 control-label">{capitalize(lang.estilo)} (<a blank href="https://worldbeermap.com/types.html" target="_BLANK">?</a>)</label>
                            <div className="col-md-6 selectContainer">
                            <div className="input-group">
                                <span className="input-group-addon"><i className="glyphicon glyphicon-list"></i></span>
                                <Select name="style" className="select-S" onChange={this.myChangeHandlerStyle} options={styles_beers} />
                        </div>
                        </div>
                        </div>

                        

                        <div className="form-group">
                        <label className="col-md-6 control-label">{capitalize(lang.alcoholPercent)}</label>  
                        <div className="col-md-6 inputGroupContainer">
                            <div className="input-group">
                                <span className="input-group-addon"><i className="glyphicon glyphicon-user"></i></span>
                                <input  type="number" placeholder={lang.alcoholPercent_placeholder}  name="alcoholPercent" value={this.state.alcoholPercent} onChange={this.myChangeHandler} className="form-control" pattern="^\d*(\.\d{0,2})?$" step=".01"/>
                            </div>
                        </div>
                        </div>

                        

                        <div className="form-group">
                        <label className="col-md-6 control-label">{capitalize(lang.priceHappyHour)} (€)</label>  
                        <div className="col-md-6 inputGroupContainer">
                            <div className="input-group">
                                <span className="input-group-addon"><i className="glyphicon glyphicon-user"></i></span>
                                <input  type="number" placeholder={lang.priceHappyHour_placeholder}  name="priceHappyHour" value={this.state.priceHappyHour} onChange={this.myChangeHandler} className="form-control" pattern="^\d*(\.\d{0,2})?$" step=".01"/>
                            </div>
                        </div>
                        </div>

                        
                        
                        <div className="form-group"> 
                        <label className="col-md-6 control-label">{capitalize(lang.ingredients)}</label>
                            <div className="col-md-6 selectContainer">
                            <div className="input-group">
                                <span className="input-group-addon"><i className="glyphicon glyphicon-list"></i></span>
                                <textarea rows="1" name="ingredients" onChange={this.myChangeHandler} className="form-control">{this.state.ingredients}</textarea>
                        </div>
                        </div>
                        </div>

                        <div className="form-group">
                        <label className="col-md-6 control-label" >{capitalize(lang.marca)}</label> 
                            <div className="col-md-6 inputGroupContainer">
                            <div className="input-group">
                        <span className="input-group-addon"><i className="glyphicon glyphicon-user"></i></span>
                            <input  name="brand" placeholder={lang.brand_placeholder} value={this.state.brand} onChange={this.myChangeHandler} className="form-control"  type="text"/>
                            </div>
                        </div>
                        </div>

                        <div className="form-group">
                        <label className="col-md-6 control-label" >{capitalize(lang.country)}</label> 
                            <div className="col-md-6 inputGroupContainer">
                            <div className="input-group">
                        <span className="input-group-addon"><i className="glyphicon glyphicon-user"></i></span>
                            <input  name="country" value={this.state.country} onChange={this.myChangeHandler} className="form-control"  type="text"/>
                            </div>
                        </div>
                        </div>

                        <div className="form-group">
                        <label className="col-md-6 control-label" >{capitalize(lang.withoutGluten)}</label> 
                            <div className="col-md-1 inputGroupContainer">
                                <input  name="withoutGluten"  value={this.state.withoutGluten} onChange={this.myChangeHandler} className="form-control"  type="checkbox"/>
                            </div>
                        </div>
                                    
                        <div className="form-group">
                        <label className="col-md-6 control-label" >{capitalize(lang.rating)}</label> 
                            <div className="col-md-6 inputGroupContainer">
                            <span className="input-group-addon"><i className="glyphicon glyphicon-user"></i></span>
                            <FontAwesomeIcon color={this.state.rating > 0 ? 'orange' : ''} icon={faStar} onClick={this.myClickStar(1)}/>
                            <FontAwesomeIcon color={this.state.rating > 1 ? 'orange' : ''} icon={faStar} onClick={this.myClickStar(2)}/>
                            <FontAwesomeIcon color={this.state.rating > 2 ? 'orange' : ''} icon={faStar} onClick={this.myClickStar(3)}/>
                            <FontAwesomeIcon color={this.state.rating > 3 ? 'orange' : ''} icon={faStar} onClick={this.myClickStar(4)}/>
                            <FontAwesomeIcon color={this.state.rating > 4 ? 'orange' : ''} icon={faStar} onClick={this.myClickStar(5)}/>
                            </div>
                        </div>

                        <div className="form-group">
                        <label className="col-md-6 control-label" >{capitalize(lang.comment)}</label> 
                            <div className="col-md-6 inputGroupContainer">
                                <span className="input-group-addon"><i className="glyphicon glyphicon-list"></i></span>
                                <textarea rows="3" name="comment" onChange={this.myChangeHandler} className="form-control">{this.state.ingredients}</textarea>
                            </div>
                        </div>
                        
                    
                        <div className="form-group col-md-6">
                            <div className="card">
                            <div className="card-header">
                                {capitalize(lang.add_photos_beer)}
                            </div>
                            <div className="card-body">
                                <MultipleImageUploadComponent handleStateChangeLP ={this.handleStateChangeLP }/>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>

                

                

                
                <div className="form-group">
                    <label className="col-md-6 control-label"></label>
                    <div className="col-md-6"><button type="submit" className="btn btn-warning" >{lang.submit.toUpperCase()} <span className="glyphicon glyphicon-send"></span></button>
                    </div>
                </div>
                
                </fieldset>
                </form>
                </div>                
                
                
        );
        }
    }
};

export default withRouter(Add);
